// Roles soportados en auth
const Role = Object.freeze({
    BUYER: 'comprador',
    SELLER: 'vendedor',
    ADMIN: 'administrador'
});

// Labels para UI (ES)
const RoleLabels = Object.freeze({
  [Role.BUYER]: 'Comprador',
  [Role.SELLER]: 'Vendedor',
  [Role.ADMIN]: 'Administrador',
});

(function exposeGlobals() {
  if (typeof module !== 'undefined' && module.exports) {    
    module.exports = {
        Role,
        RoleLabels
    }
  } else if (typeof window !== 'undefined') {
    window.Role = Role;
    window.RoleLabels = RoleLabels;
  }
})();